import { render, staticRenderFns } from "./article-listing.vue?vue&type=template&id=551dd22b"
import script from "./article-listing.vue?vue&type=script&lang=js"
export * from "./article-listing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports